var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChordAMinor = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 600 600",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#8d6db0",
  strokeMiterlimit: 10,
  strokeWidth: 26.04,
  d: "M302.74 467.35L104.31 126.03h394.64L302.74 467.35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#8d6db0",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M362.85 475.73a61.64 61.64 0 11-61.64-61.63 61.64 61.64 0 0161.64 61.63z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#ef3e30",
  strokeMiterlimit: 10,
  strokeWidth: 22.43,
  d: "M164.56 121.71a61.64 61.64 0 11-61.63-61.63 61.64 61.64 0 0161.63 61.63z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6db0",
  stroke: "#8d6db0",
  strokeMiterlimit: 10,
  strokeWidth: 4.88,
  d: "M293 484.25l-5 15.05h-6.39l16.26-47.85h7.45l16.33 47.85h-6.6L310 484.25zm15.69-4.83L304 465.65c-1.06-3.12-1.77-6-2.48-8.73h-.14c-.71 2.84-1.5 5.75-2.42 8.66l-4.68 13.84z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ef3e30",
  stroke: "#ef3e30",
  strokeMiterlimit: 10,
  strokeWidth: 8.01,
  d: "M118.27 140.89c-2.28 1.14-6.82 2.27-12.64 2.27C92.14 143.16 82 134.64 82 119c0-15 10.15-25.13 25-25.13 6 0 9.72 1.28 11.36 2.13l-1.49 5a22.47 22.47 0 00-9.66-2c-11.21 0-18.69 7.17-18.69 19.74 0 11.71 6.74 19.24 18.39 19.24A24.69 24.69 0 00117 136z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6db0",
  stroke: "#8d6db0",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  d: "M232.7 292.66a15 15 0 0011.63-6.55q2.82-3.81 8.11-16.8l44.46-109.54h5.56l44.66 105.14q7.53 17.68 11.24 22.82t10.55 4.93v5.08h-64.78v-5.08q9.76-.39 12.85-1.66t3.07-6.45a25.81 25.81 0 00-1.56-7.13q-1-2.84-2.64-6.84l-5.09-12.12h-44.93q-4.41 11.93-5.68 15.54-2.62 7.71-2.63 11.23 0 4.31 5.76 6.26a38.08 38.08 0 0010.26 1.17v5.08H232.7zm75.12-42.11l-19.25-46.32h-1.68l-18.06 46.32zm34.87-30.64a6.12 6.12 0 002.93-.91c.87-.69 1.3-2 1.3-3.82v-23c0-1.64-.29-2.76-.88-3.34a5.75 5.75 0 00-3.35-1.2v-1.87h14.79v5.61a21.43 21.43 0 013.78-4 12.27 12.27 0 017.55-2.55q4.69 0 7.29 2.21a12 12 0 012.74 4.12h.54a20.34 20.34 0 014.23-4.08 11.9 11.9 0 017-2.25 11 11 0 017.27 2.63c2.1 1.75 3.14 4.53 3.14 8.31v19.65c0 1.8.3 2.95.88 3.45a5.89 5.89 0 003.09 1v1.87h-18.56v-1.87a5.76 5.76 0 003-1c.56-.49.84-1.62.84-3.37v-18.93a10.17 10.17 0 00-.9-4.73 3.5 3.5 0 00-3.41-1.68 6.84 6.84 0 00-4.26 1.85c-1.48 1.24-2.23 2.09-2.23 2.58v20.9c0 1.7.26 2.79.77 3.28a6 6 0 002.86 1.14v1.87h-18.29v-1.87a5.69 5.69 0 002.93-1c.59-.5.88-1.63.88-3.41v-18.93a10.81 10.81 0 00-.84-4.69c-.56-1.15-1.71-1.72-3.47-1.72a6.39 6.39 0 00-4.46 2c-1.37 1.32-2.06 2.14-2.06 2.47v20.9c0 1.7.24 2.79.72 3.28a5.85 5.85 0 002.87 1.14v1.87h-18.69z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M558.71 118.07a61.64 61.64 0 11-61.63-61.63 61.64 61.64 0 0161.63 61.63z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#eada1b",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M511.7 119.21h-18.6v17.25h20.73v5.18h-26.9V93.79h25.84V99H493.1v15.12h18.6z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChordAMinor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chord-a-minor.c0aa79a5d3ee643aafb2abf5c552dd46.svg";